/**
 * "My tasks": the tasks assigned to the signed-in person across the projects they are on, so the
 * phone and the console need no device to see or move them (B-17).
 *
 *   GET /my-tasks/v1?status=open|all   { tasks[] }  each with its project, repository and board
 *
 * The person is resolved as the boards resolve an assignee (`assigneePerson`): a saved team
 * member's name, the person's subject id, or, once among the project's members, their name or
 * email. A task is moved with the board routes (`PATCH …/tasks/:taskId`, `…/comments`) as the
 * person; the reply carries the project's role so a screen offers only what it will accept.
 *
 * "Assigned to you" is also a needs-you record addressed to the assignee, deduped per task
 * (`assigned:<root>/<board>/<task>:<person>`), whose one action is OPEN_MY_TASKS_ACTION: a client
 * opens its "My tasks" screen instead of calling the platform.
 */
export const MY_TASKS_PATH = "/my-tasks/v1";
export const OPEN_MY_TASKS_ACTION = "aioe.tasks.open";
export const ASSIGNED_DEDUPE_PREFIX = "assigned:";
/** A task that is finished and so is no longer "mine to do". */
export const taskIsClosed = (status) => status === "done" || status === "cancelled";
export function myTaskMovePatch(move, me) {
    switch (move) {
        case "take":
            return { assignee: me };
        case "start":
            return { status: "in-progress" };
        case "done":
            return { status: "done" };
        case "blocked":
            return { status: "blocked" };
    }
}
//# sourceMappingURL=myTasks.js.map